<template>
  <div class="contactus">
    <div class="pic" id="bg">
      <!-- src="/static/img/sk/contact.png" -->
      <img
        src="/static/img/sk/contactus.png"
        width="100%"
        alt="Contact Sharkgulf"
      />
      <!-- <div class="loc" @click="Tobaidumap"></div> -->
      <div class="info">
        <div class="infotitle">Blueshark Korea<br />Co., Ltd.</div>
        <div class="address">
          256, Toegye-ro, Jung-gu, Seoul, Republic of Korea
        </div>
        <div class="email">+82.1811.6540</div>
        <div class="email">info@bluesharkkorea.com</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loc: ''
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    let width = document.body.clientWidth
    this.loc = width * 0.4 + ',' + width * 0.26 + ',' + '50'
  },
  methods: {
    // Tobaidumap() {
    //   window.open(
    //     'https://map.baidu.com/search/%E4%B8%8A%E6%B5%B7%E5%B8%82%E9%97%B5%E8%A1%8C%E5%8C%BA%E5%AE%9C%E5%B1%B1%E8%B7%AF1698%E5%8F%B7%E5%85%B4%E8%BF%AA%E5%95%86%E5%8A%A1%E5%A4%A7%E5%8E%A6/@13513925.41415,3633117.008025,19z?querytype=con&wd=%E4%B8%8A%E6%B5%B7%E5%B8%82%E9%97%B5%E8%A1%8C%E5%8C%BA%E5%AE%9C%E5%B1%B1%E8%B7%AF1698%E5%8F%B7%E5%85%B4%E8%BF%AA%E5%95%86%E5%8A%A1%E5%A4%A7%E5%8E%A6&c=289&provider=pc-aladin&pn=0&device_ratio=1&da_src=shareurl'
    //   )
    // }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';
.contactus {
  background-color: #000;
  min-height: calc(100vh - 120px);
  .pic {
    font-size: 0;
    position: relative;
    overflow: hidden;
    .loc {
      position: absolute;
      width: 60px;
      height: 80px;
      left: 38vw;
      top: 23.3vw;
      z-index: 1;
      cursor: pointer;
    }
    .info {
      position: absolute;
      background-color: #fff;
      padding: 60px 40px;
      top: 15vw;
      width: 220px;
      right: 15vw;
      .infotitle {
        color: @colorblue;
        font-size: 20px;
        font-weight: bold;
      }
      .address {
        font-size: 14px;
        margin-top: 30px;
        color: #666;
      }
      .email {
        font-size: 14px;
        margin-top: 20px;
        color: #666;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sk/contactus.vue